import { ScrubbingStatusId } from '../../models';

export const PASS_INELIGIBLE_TOOLTIP =
  'Select at least one nomination. Remove nominations that have already passed from your selection.';

export function isPassEligibleScrubbingStatus(scrubbingStatusId: number): boolean {
  return scrubbingStatusId !== ScrubbingStatusId.Passed;
}

export function areAllSelectedPassEligible(selected: { scrubbingStatusId: number }[]): boolean {
  return selected.length > 0
    && selected.every(selectedNomination => isPassEligibleScrubbingStatus(selectedNomination.scrubbingStatusId));
}
